import { GC_GET_PROPOSAL_LIST } from '@/graphql/proposal'
import apollo from '@/apolloClient'

export default {
    namespaced: true,
    state: {
        list: [],
    },
    mutations: {
        SET_PROPOSAL_LIST(state, proposals) {
            state.list = (proposals || []);
        }
    },
    actions: {
        async getList({ commit }) {
            const response = await apollo.query({ query: GC_GET_PROPOSAL_LIST })

            commit('SET_PROPOSAL_LIST', response.data.proposal)
        },
    }
}